<cc-section>
  <!--  <div class="flex" *ngIf="subscription$ | async as subscription">-->
  <div class="plan-section" *ngIf="subscription$ | async as subscription">
    <cc-current-plan
      [subscription]="subscription"
      class=""
    ></cc-current-plan>
    <cc-webcall-balance>
    </cc-webcall-balance>
  </div>
  <cc-phone-numbers-plan [subscription]="subscription$ | async" class=""></cc-phone-numbers-plan>
  <cc-balance [card]="card$ |async" [cardMetadata]="cardMetadata$ | async"></cc-balance>
  <cc-card [card]="card$ | async" (cardChange)="onChangeCard()" *ngIf="(cardMetadata$ |async)?.attachable"></cc-card>
  <cc-cancel-account
    *ngIf="!(subscription$ | async)?.cancelAtPeriodEnd && (subscription$ | async)?.status !== 'TRIAL'"></cc-cancel-account>
</cc-section>
